<div class="col-md-3 col-lg-4 filter-col">
  <div class="form-group">
    <app-search-filter
      #searchFilter
      [hidden]="filterHidden"
      [disabled]="disabled"
      [options]="options"
      (changeEvent)="searchInput.value = undefined; changeFilter($event)"
    ></app-search-filter>
  </div>
</div>
<div class="col-md-9 col-lg-8 input-col">
  <div class="form-group input-wrapper">
    <app-search-input
      #searchInput
      [searchBar]="this"
      [inputType]="searchFilter?.selectedOption?.inputType"
      [options]="searchFilter?.selectedOption?.options"
      [disabled]="searchFilter.selectedOption?.value ? false : inputDisabled || disabled"
      [searching]="searching"
      [selectedFilter]="searchFilter?.selectedOption"
      (changeEvent)="search($event)"
      (asyncChangeEvent)="asyncSearch($event)"
    >
    </app-search-input>
  </div>
  <div *ngIf="!iconHidden" class="form-group">
    <button mat-button [disabled]="searchInput.isDisabled()" (click)="search(searchInput.value)">
      <mat-icon class="icon-search" matSuffix>search</mat-icon>
    </button>
  </div>
</div>
